import Swiper from 'swiper';

document.addEventListener('DOMContentLoaded', function() {
    LogoSlider();
});

function LogoSlider() {
    var swipers = document.querySelectorAll('.swiper.slider-logos');

    swipers.forEach(function(swiper) {

        var swiperSlider = new Swiper(swiper, {
            loop: false,
            autoplay: {
              delay: 500
            },
            speed: 500,
            slidesPerView: 2,
            spaceBetween: 32,
            keyboard: {
                enabled: true,
            },
            breakpoints: {
                786: {
                    slidesPerView: 4,
                },
                1024: {
                    slidesPerView: 6,
                }
            }
        });

    });
}